import { render, staticRenderFns } from "./NuxtContent.vue?vue&type=template&id=7fe7957f&"
import script from "./NuxtContent.vue?vue&type=script&lang=js&"
export * from "./NuxtContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports